export const itemTaxBreakdownAvailable = item => item?.snapshot?.tax_breakdown_available !== false;
export function taxBreakdownAvailable(order) {
    return order?.tax_breakdown_available !== false
        && (order?.items || []).every(itemTaxBreakdownAvailable)
        && (order?.shipping || order?.pricing_snapshot?.shipping)?.tax_breakdown_available !== false;
}
